"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencySymbol = exports.getCurrencySymbolFromCode = void 0;
function getCurrencySymbolFromCode(code) {
    return exports.currencySymbol[code];
}
exports.getCurrencySymbolFromCode = getCurrencySymbolFromCode;
exports.currencySymbol = {
    AED: 'د.إ',
    AFN: '؋',
    ALL: 'L',
    AMD: '֏',
    ANG: 'NAƒ',
    AOA: 'Kz',
    ARS: '$',
    AUD: 'A$',
    AWG: 'Afl',
    AZN: '₼',
    BAM: 'KM',
    BBD: 'Bds$',
    BDT: '৳',
    BGN: 'лв.',
    BHD: 'BD',
    BIF: 'FBu',
    BMD: '$',
    BND: 'B$',
    BOB: 'Bs',
    BOV: '',
    BRL: 'R$',
    BSD: 'B$',
    BTN: 'Nu.',
    BWP: 'P',
    BYN: 'Br',
    BZD: 'BZ$',
    CAD: 'C$',
    CDF: 'FC',
    CHE: '',
    CHF: 'Fr.',
    CHW: '',
    CLF: '',
    CLP: '$',
    CNY: '¥',
    COP: '$',
    COU: '',
    CRC: '₡',
    CUC: '$',
    CUP: '₱',
    CVE: '$',
    CZK: 'Kč',
    DJF: 'Fdj',
    DKK: 'kr.',
    DOP: 'RD$',
    DZD: 'DA',
    EGP: 'E£',
    ERN: 'Nfk',
    ETB: 'Br',
    EUR: '€',
    FJD: 'FJ$',
    FKP: '£',
    GBP: '£',
    GEL: '₾',
    GHS: 'GH₵',
    GIP: '£',
    GMD: 'D',
    GNF: 'FG',
    GTQ: 'Q',
    GYD: 'G$',
    HKD: 'HK$',
    HNL: 'L',
    HRK: 'kn',
    HTG: 'G',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼ ',
    ISK: 'kr',
    JMD: '$',
    JOD: '',
    JPY: '¥',
    KES: 'KSh',
    KGS: 'som',
    KHR: '៛',
    KMF: 'CF',
    KPW: '₩',
    KRW: '₩',
    KWD: 'د.ك',
    KYD: '$',
    KZT: '₸',
    LAK: '₭',
    LBP: 'ل.ل.‎',
    LKR: 'රු',
    LRD: 'L$',
    LSL: 'M',
    LYD: 'LD',
    MAD: 'MAD',
    MDL: 'lei',
    MGA: 'Ar',
    MKD: 'ден',
    MMK: 'K',
    MNT: '₮',
    MOP: 'MOP$',
    MRU: 'undefined',
    MUR: '₨',
    MVR: 'Rf',
    MWK: 'MK',
    MXN: 'Mex$',
    MXV: '',
    MYR: 'RM',
    MZN: 'MT',
    NAD: 'N$',
    NGN: '₦',
    NIO: 'C$',
    NOK: 'kr',
    NPR: 'रू',
    NZD: '$',
    OMR: 'ر.ع.',
    PAB: 'B/.',
    PEN: 'S/',
    PGK: 'K',
    PHP: '₱',
    PKR: 'Rupees',
    PLN: 'zł',
    PYG: '₲',
    QAR: 'QR',
    RON: 'lei',
    RSD: '',
    RUB: '₽',
    RWF: 'R₣',
    SAR: 'SR',
    SBD: 'SI$',
    SCR: 'SR',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: 'S$',
    SHP: '£',
    SLL: 'Le',
    SOS: 'Sh.',
    SRD: '$',
    SSP: '',
    STN: 'undefined',
    SVC: '₡',
    SYP: '',
    SZL: 'L',
    THB: '฿',
    TJS: '',
    TMT: 'T',
    TND: 'DT',
    TOP: 'T$',
    TRY: '₺',
    TTD: 'TT$',
    TWD: 'NT$',
    TZS: 'TSh',
    UAH: '₴',
    UGX: 'USh',
    USD: '$',
    USN: '',
    UYI: '',
    UYU: '$U',
    UYW: 'undefined',
    UZS: 'som',
    VES: 'undefined',
    VND: '₫',
    VUV: 'VT',
    WST: 'WS$',
    XAF: 'FCFA',
    XAG: '',
    XAU: '',
    XBA: '',
    XBB: '',
    XBC: '',
    XBD: '',
    XCD: '$',
    XDR: 'SDR',
    XOF: 'CFA',
    XPD: '',
    XPF: '₣',
    XPT: '',
    XSU: 'Sucre',
    XTS: 'TEST',
    XUA: '',
    XXX: 'none',
    YER: '﷼',
    ZAR: 'R',
    ZMW: 'ZK',
    ZWL: 'Z$'
};
const availableSymbols = [
    'د.إ', '؋', 'L', '֏', 'NAƒ', 'Kz', '$', 'A$', 'Afl', '₼', 'KM', 'Bds$', '৳', 'лв.', 'BD', 'FBu', '$', 'B$', 'Bs',
    'R$', 'B$', 'Nu.', 'P', 'Br', 'BZ$', 'C$', 'FC', 'Fr.', '$', '¥', '$', , '₡', '$', '₱', '$', 'Kč', 'Fdj',
    'kr.', 'RD$', 'DA', 'E£', 'Nfk', 'Br', '€', 'FJ$', '£', '£', '₾', 'GH₵', '£', 'D', 'FG', 'Q', 'G$', 'HK$', 'L', 'kn', 'G',
    'Ft', 'Rp', '₪', '₹', 'ع.د', '﷼ ', 'kr', '$', '¥', 'KSh', 'som', '៛', 'CF', '₩', '₩', 'د.ك', '$', '₸', '₭', 'ل.ل.‎', 'රු',
    'L$', 'M', 'LD', 'MAD', 'lei', 'Ar', 'ден', 'K', '₮', 'MOP$', '₨', 'Rf', 'MK', 'Mex$', 'RM', 'MT', 'N$', '₦',
    'C$', 'kr', 'रू', '$', 'ر.ع.', 'B/.', 'S/', 'K', '₱', 'Rupees', 'zł', '₲', 'QR', 'lei', '₽', 'R₣', 'SR', 'SI$', 'SR', 'ج.س.',
    'kr', 'S$', '£', 'Le', 'Sh.', '$', '₡', 'L', '฿', 'T', 'DT', 'T$', '₺', 'TT$', 'NT$', 'TSh', '₴', 'USh',
    '$', '$U', 'som', '₫', 'VT', 'WS$', 'FCFA', '$', 'SDR', 'CFA', '₣',
    'Sucre', 'TEST', 'none', '', 'undefined', '﷼', 'R', 'ZK', 'Z$'
];
